import React from "react";
import { dataTestIds } from "data-testids";
import { InscribedCrossIcon } from "assets";
import "./InputCleaner.scss";

export interface IInputCleanerProps {
  /** Optional handler to hook into the click event. */
  onClick?: (event: React.MouseEvent<Element, MouseEvent>) => void;
}

export const InputCleaner: React.FC<
  React.PropsWithChildren<IInputCleanerProps>
> = ({ onClick }) => {
  return (
    <div className="c-cleaner__container">
      <div
        onClick={onClick}
        className="c-cleaner"
        data-testid={
          dataTestIds.componentLibrary["Atoms.InputsCommon.inputCleaner"]
        }
      >
        <InscribedCrossIcon width={20} height={20} />
      </div>
    </div>
  );
};
